<template>
  <span v-if="productName" style="font-weight: bold" v-html="productName">
  </span>
  <div v-if="productName" class="product-tile__overlay-separator" />
  <span v-if="soundsIncluded" class="product-tile__overlay-meta-span">
    {{ soundsIncluded }} sounds included<template v-if="totalDuration"> • {{ totalDuration }} min total</template>
  </span>
  <span v-else-if="filesIncluded" class="product-tile__overlay-meta-span">
    {{ filesIncluded }} files included<template v-if="totalDuration"> • {{ totalDuration }} min total</template>
  </span>
</template>

<script setup lang="ts">
  const props = defineProps<{
    productName?: string;
    totalDuration?: string;
    filesIncluded?: string;
    soundsIncluded?: string;
  }>();
</script>